import { StaticImageData } from "next/image";
import portfolio_mnt_covid_lockdown from "@/assets/img/portfolio/MNT-COVID-lockdown-immune-systems.webp";
import portfolio_mnt_through_my_eyes from "@/assets/img/portfolio/MNT-through-my-eyes.webp";
import portfolio_mnt_top_health_news from "@/assets/img/portfolio/MNT-top-health-news2.avif";
import portfolio_zoe_a_day_in_the_life_of_dr_sarah_berry from "@/assets/img/portfolio/ZOE-A-day-in-the-life-of-dr-sarah-berry.avif";
import portfolio_zoe_zoe_academy from "@/assets/img/portfolio/ZOE-zoe-academy2.avif";
import portfolio_zoe_zoe_homepage from "@/assets/img/portfolio/ZOE-zoe-homepage-4.jpeg";
import portfolio_zoe_zoe_members_snacks from "@/assets/img/portfolio/ZOE-zoe-members-favourite-snacks.avif";
import portfolio_photon_lock_stock from "@/assets/img/portfolio/Photon-lock-stock-and-200-smoking-modules2.jpeg";
import portfolio_books from "@/assets/img/portfolio/books.jpg";

interface DataType {
  id: number;
  image: StaticImageData;
  imageDescription?: string;
  tags: string[];
  title: string;
  description?: string;
  summary?: string;
  url: string;
  ctaText: string;
  style?: React.CSSProperties;
}

const testimonial_data: DataType[] = [
  {
    id: 2,
    image: portfolio_zoe_zoe_homepage,
    tags: ["Tone of Voice", "ZOE"],
    title: "Tone of voice strategy across ZOE",
    url: "https://zoe.com/",
    description:
      "Working with stakeholders at all levels of the business, I helped craft, deliver and roll out ZOE’s tone of voice across all departments.",
    ctaText: "Visit zoe.com",
  },
  {
    id: 3,
    image: portfolio_mnt_covid_lockdown,
    tags: ["Science Writing", "Medical News Today"],
    title: "COVID lockdowns and our immune systems",
    url: "https://www.medicalnewstoday.com/articles/how-have-pandemic-lockdowns-affected-the-immune-system",
    description:
      "With over a decade of experience writing health and science content, I’m well-versed in researching and writing credible features, such as this one.",
    ctaText: "View Article",
  },
  {
    id: 1,
    image: portfolio_books,
    tags: ["Editing", "Ghostwriting"],
    title: "Book projects",
    url: "#",
    description:
      "Working on books is my first love. For writing samples from previous book projects, reach out to me directly.",
    ctaText: "",
  },
  {
    id: 4,
    image: portfolio_mnt_through_my_eyes,
    tags: ["Blog Writing", "Medical News Today"],
    title: "Through my eyes",
    url: "https://www.medicalnewstoday.com/articles/through-my-eyes-how-lockdown-anxiety-with-a-newborn-broke-me",
    description:
      "I particularly enjoy writing lifestyle and thought pieces, such as this one about my experience navigating the pandemic with a newborn and a 5-year-old.",
    ctaText: "View Article",
    style: {
      backgroundPosition: "bottom right",
    },
  },

  {
    id: 5,
    image: portfolio_zoe_a_day_in_the_life_of_dr_sarah_berry,
    tags: ["Feature Writing", "ZOE"],
    title: "A day in the life of Dr Sarah Berry",
    url: "https://zoe.com/learn/a-day-in-the-life-of-dr-sarah-berry",
    description:
      "When ghostwriting or chronicling other people’s experiences, I pull from my journalism background – as with this piece that followed Dr Sarah Berry for a day in her life.",
    ctaText: "View Article",
  },

  {
    id: 6,
    image: portfolio_photon_lock_stock,
    tags: ["News Writing", "PHOTON Magazine"],
    title: "Guy Ritchie’s solar panels",
    url: "https://drive.google.com/file/d/1Zc38NTK50Fb6Eq4vGvGtDtk-6NbUVxRD/view",
    description:
      "My early career involved reporting on the politics and technology of solar power. In this piece, I report on director Guy Ritchie’s new solar panels.",
    ctaText: "Download PDF",
  },
  {
    id: 7,
    image: portfolio_zoe_zoe_academy,
    tags: ["SEO and Features", "ZOE"],
    title: "ZOE Academy",
    url: "https://zoe.com/learn",
    description:
      "I’m experienced in creating SEO strategies for publishers and businesses from scratch, such as the top-performing Academy content I led at ZOE.",
    ctaText: "Visit zoe.com/learn",
  },
  {
    id: 8,
    image: portfolio_zoe_zoe_members_snacks,
    tags: ["Member-serving content", "ZOE"],
    title: "ZOE members’ favourite snacks",
    url: "https://zoe.com/learn/zoe-members-favorite-snacks",
    description:
      "I developed the strategy for lead magnet and member-serving content at ZOE, which engaged members and pulled potential ones further into the funnel.",
    ctaText: "Read Article",
  },
  {
    id: 9,
    image: portfolio_mnt_top_health_news,
    tags: ["News strategy", "Medical News Today"],
    title: "Medical News Today - top health news",
    url: "https://www.medicalnewstoday.com/",
    description:
      "As Managing Editor at Medical News Today, I led the news strategy for years, bringing us into the top 10 health websites in the world – and eventually into the number three position.",
    ctaText: "Visit medicalnewstoday.com",
  },
];
export default testimonial_data;
